module.exports = __webpack_public_path__ + "06_short_brown.64df9c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_short_brown.png
// module id = c/tf
// module chunks = 0